import { useCommonReducer } from '@components/Shared/State/hooks';
import { GetAccountSettings } from '@themes/common/data';
const { customers_account_title } = GetAccountSettings().translations;
const useBanner = () => useCommonReducer('ACCOUNT_BANNER', {
    title: customers_account_title,
});
export default useBanner;
